import api from '../../router/api';
import moment from 'moment';
import { FileFolderEntityType, ONEServiceTypeInfo, ONEServiceType, ResultValue, SystemInfoType, OrderBy } from '../objects.js';
import { isValid } from '../utilitiesmodule.js';
import { OneSignalSetup } from '../OneSignalSetup.js';
export function installVuePrototypes(Vue) {
    Vue.filter('utcAsLocal', function (value) {
        return moment.utc(value).local();
    });

    Vue.filter('utcStringToLocal', function (value, format = "LLLL") {
        if (!isValid(value)) return "";
        return moment
            .utc(value, "YYYYMMDDHH:mm:ss") // parse stringa UTC
            .local()                        // converte al fuso locale
            .format(format);                // format finale
    });

    Vue.prototype.$api = api;
    Vue.prototype.$FileFolderEntityType = FileFolderEntityType;
    Vue.prototype.$ONEServiceType = ONEServiceType;
    Vue.prototype.$ONEServiceTypeInfo = ONEServiceTypeInfo;
    Vue.prototype.$ResultValue = ResultValue;
    Vue.prototype.$SystemInfoType = SystemInfoType;
    Vue.prototype.$OrderBy = OrderBy;
    Vue.prototype.$session.getServiceAccounts = function () {
        if (!this.has("SERVICEACCOUNTS"))
            this.set("SERVICEACCOUNTS", []);
        return this.get("SERVICEACCOUNTS");
    }

    Vue.prototype.$session.getServiceAccountsWithTypeIn = function (types) {
        if (!this.has("SERVICEACCOUNTS"))
            this.set("SERVICEACCOUNTS", []);

        var serviceAccounts = this.get("SERVICEACCOUNTS");
        var filteredServiceAccounts = serviceAccounts.filter(sa => types.includes(sa.type));

        //Si ricorda che il tipo database è strettamente collegato al computer.
        //Quindi sto cercando i service account dei database
        if (types[0].isDatabase()) {
            //controllo se sono in un pc
            var roomPC = this.getRoomPC();
            //Se sono in un pc, ritorno i service account dei database di quel pc
            if (roomPC != null) {
                return filteredServiceAccounts.filter(sa => sa.options.lastTestPC == roomPC.id);
            }
        }

        return filteredServiceAccounts
    }

    Vue.prototype.$session.setServiceAccounts = function (list) {
        this.set("SERVICEACCOUNTS", list);
    }

    Vue.prototype.$session.getServiceAccountWithID = function (id) {
        var serviceAccounts = this.getServiceAccounts();
        var sa = serviceAccounts.find(sa => sa.id == id)
        if (sa == undefined)
            return null;
        return sa;
    }

    Vue.prototype.$session.getServiceAccountOfRepositoryWithID = function (idRepo) {
        var repo = this.getRepositoryWithID(idRepo);
        if (repo == null || [null, "", -2, "-2"].includes(repo.id_service_account)) {
            return null;
        }

        return this.getServiceAccountWithID(repo.id_service_account);
    }

    Vue.prototype.$session.addServiceAccount = function (sa) {
        var serviceAccounts = this.getServiceAccounts();
        serviceAccounts.push(sa);
        this.set("SERVICEACCOUNTS", serviceAccounts);
    }

    Vue.prototype.$session.editServiceAccount = function (sa) {
        var serviceAccounts = this.getServiceAccounts();

        var saIndex = serviceAccounts.findIndex(s => s.id == sa.id);
        if (saIndex == -1)
            serviceAccounts.push(sa);
        else
            serviceAccounts[saIndex] = sa;
        this.set("SERVICEACCOUNTS", serviceAccounts);

    }

    Vue.prototype.$session.deleteServiceAccount = function (idSA) {
        var serviceAccounts = this.getServiceAccounts();
        var saIndex = serviceAccounts.findIndex(s => s.id == idSA);
        if (saIndex == -1)
            return;
        serviceAccounts.splice(saIndex, 1);
        this.set("SERVICEACCOUNTS", serviceAccounts);

    }

    /*****************************SESSION - REPOSITORIES*****************************************************************************************************/
    Vue.prototype.$session.getRepositories = function () {
        return this.has("REPOSITORIES") ?
            this.get("REPOSITORIES") : [];
    }

    Vue.prototype.$session.getRepositoriesWithTypeIn = function (types) {
        if (!this.has("REPOSITORIES"))
            this.set("REPOSITORIES", []);
        var repositories = this.get("REPOSITORIES");
        return repositories.filter(repo => types.includes(repo.type))
    }

    Vue.prototype.$session.setRepositories = function (list) {
        this.set("REPOSITORIES", list);
    }

    Vue.prototype.$session.getRepositoryWithID = function (id) {
        var repositories = this.getRepositories();

        var repo = repositories.find(r => r.id == id)
        if (repo == undefined)
            return null;
        return repo;
    }

    Vue.prototype.$session.addRepository = function (repo) {
        var repositories = this.getRepositories();

        repositories.push(repo);
        this.set("REPOSITORIES", repositories);
    }

    Vue.prototype.$session.editRepository = function (repo) {
        var repositories = this.getRepositories();

        var repoIndex = repositories.findIndex(r => r.id == repo.id);
        if (repoIndex == -1)
            repositories.push(repo);
        else
            repositories[repoIndex] = repo;
        this.set("REPOSITORIES", repositories);

    }

    Vue.prototype.$session.deleteRepository = function (idRepo) {
        var repositories = this.getRepositories();

        var repoIndex = repositories.findIndex(r => r.id == idRepo);
        if (repoIndex == -1)
            return;
        repositories.splice(repoIndex, 1);
        this.set("REPOSITORIES", repositories);

    }

    /*****************************SESSION - COMPUTERS*****************************************************************************************************/
    Vue.prototype.$session.getPCList = function () {
        return this.has("COMPUTERS") ?
            this.get("COMPUTERS") : [];
    }

    Vue.prototype.$session.setPCList = function (list) {
        this.set("COMPUTERS", list);
    }

    Vue.prototype.$session.getPCWithID = function (idPC) {
        if (!this.has("COMPUTERS")) {
            return null;
        }

        //mappa {id :pc, ...}
        var pcs = this.get("COMPUTERS");
        var pc = pcs.find(x => x.id == idPC);
        if (pc == undefined) {
            return null;
        }
        return pc;
    }

    Vue.prototype.$session.hasPCList = function () {
        return this.has("COMPUTERS");
    }

    Vue.prototype.$session.editPC = function (idPC, newPC) {
        var pcs = this.get("COMPUTERS");
        var index = pcs.findIndex(x => x.id == idPC);
        pcs[index] = newPC;
        this.setPCList(pcs);
    }

    /*     Vue.prototype.$session.getPCsConnections = function() {
            return this.has("PCSCONNECTIONS") ?
                this.get("PCSCONNECTIONS") : [];
        }

        //{
        //    idPC : true/false
        //    ...
        //}
        Vue.prototype.$session.setPCsConnections = function(idPC_isConnected) {
            this.set("PCSCONNECTIONS", idPC_isConnected);
            var roomPC = this.getRoomPC();
            if (roomPC == null) {
                this.set("ONEISCONNECTED", Object.values(idPC_isConnected).some(isConnectedValue => isConnectedValue));
            } else {
                this.set("ONEISCONNECTED", idPC_isConnected[roomPC.id])
            }
        } */


    /*****************************SESSION - GROUPS*****************************************************************************************************/
    Vue.prototype.$session.getGroups = function (includeNoPCs = true, includeNoUsers = true) {

        if (!this.has("GROUPS"))
            return [];
        var groups = this.get("GROUPS");

        if (!includeNoPCs) {
            groups.removeIf(g => g.num_computers == 0);
        }

        if (!includeNoUsers) {
            groups.removeIf(g => g.num_users == 0);
        }

        return groups;

    }
    Vue.prototype.$session.setGroups = function (groups) {
        this.set("GROUPS", groups);
    }

    Vue.prototype.$session.getGroupWithID = function (idGroup) {
        var groups = this.getGroups();
        if (groups.length == 0) {
            return null;
        }

        //mappa {id :pc, ...}
        var group = pcs.find(x => x.id_group == idGroup);
        if (group == undefined) {
            return null;
        }
        return group;
    }

    /*****************************SESSION - POLICIES*****************************************************************************************************/
    Vue.prototype.$session.getPolicies = function (related_entity) {
        if (!this.has("POLICIES")) {
            return [];
        }
        var policies = this.get("POLICIES");
        if (related_entity) {
            policies = policies.filter(p => p.related_entity == related_entity);
        }
        return policies;
    }

    Vue.prototype.$session.setPolicies = function (policies) {
        this.set("POLICIES", policies);
    }

    Vue.prototype.$session.deletePolicy = function (idPolicy) {
        var policies = this.getPolicies();

        var policyIndex = policies.findIndex(p => p.id == idPolicy);
        if (policyIndex == -1)
            return;
        policies.splice(policyIndex, 1);
        this.set("POLICIES", policies);
    }

    Vue.prototype.$session.getPolicyWithID = function (idPolicy) {
        if (!this.has("POLICIES")) {
            return null;
        }

        //mappa {id :pc, ...}
        var policies = this.get("POLICIES");
        var policy = policies.find(x => x.id == idPolicy);
        if (policy == undefined) {
            return null;
        }
        return policy;
    }

    Vue.prototype.$session.getSchedulingPolicies = function () {
        var policies = this.getPolicies();
        if (policies.length != 0) {
            policies = policies.filter(p => p.id_type == 1);
        }
        return policies;
    }

    /*****************************SESSION - USERS*****************************************************************************************************/
    Vue.prototype.$session.getUsers = function () {
        return this.has("USERS") ?
            this.get("USERS") : [];
    }

    Vue.prototype.$session.setUsers = function (users) {
        this.set("USERS", users);
    }

    Vue.prototype.$session.saveSettings = function (userSettings) {
        this.set("userSettings", userSettings);
    }

    /*****************************SESSION - ROLES*****************************************************************************************************/
    Vue.prototype.$session.getRoles = function () {
        return this.has("ROLES") ?
            this.get("ROLES") : [];
    }

    Vue.prototype.$session.setRoles = function (roles) {
        this.set("ROLES", roles);
    }

    /*****************************SESSION - TEAMS*****************************************************************************************************/
    Vue.prototype.$session.getTeams = function () {
        return this.has("TEAMS") ?
            this.get("TEAMS") : [];
    }

    Vue.prototype.$session.setTeams = function (teams) {
        this.set("TEAMS", teams);
    }

    /*****************************SESSION - POLICY_TYPES*****************************************************************************************************/
    Vue.prototype.$session.getPolicyTypes = function (related_entity) {
        if (!this.has("POLICY_TYPES")) {
            return [];
        }
        var policiesTypes = this.get("POLICY_TYPES");
        if (related_entity) {
            policiesTypes = policiesTypes.filter(pt => pt.related_entity == related_entity);
        }
        return policiesTypes;
    }

    Vue.prototype.$session.setPolicyTypes = function (policyTypes) {
        this.set("POLICY_TYPES", policyTypes);
    }

    /*****************************SESSION - LICENSES*****************************************************************************************************/
    Vue.prototype.$session.getLicenses = function () {
        return this.has("LICENSES") ?
            this.get("LICENSES") : null; // è un oggetto
    }

    Vue.prototype.$session.setLicenses = function (licenses) {
        this.set("LICENSES", licenses);
    }

    Vue.prototype.$session.getLicense = function () {
        return this.get("LICENSE");
    }

    Vue.prototype.$session.setLicense = function (license) {
        this.set("LICENSE", license);
    }

    /*****************************SESSION - SINGOLI DATI*****************************************************************************************************/
    Vue.prototype.$session.getRoomPC = function () {
        return this.get("ROOMPC");
    }

    Vue.prototype.$session.setRoomPC = function (pc) {
        this.set("ROOMPC", pc);
    }

    Vue.prototype.$session.getAuth = function () {
        if (this.has("AUTH"))
            return this.get("AUTH");
        return JSON.parse(localStorage.getItem("AUTH"));
    }

    Vue.prototype.$session.setAuth = function (auth) {
        this.set("AUTH", auth);
    }

    Vue.prototype.$session.getLastRemoteVersion = function () {
        return this.get("LASTREMOTEVERSION");
    }

    Vue.prototype.$session.setLastRemoteVersion = function (version) {
        this.set("LASTREMOTEVERSION", version);
    }

    Vue.prototype.$OneSignalSetup = OneSignalSetup;




}
